import React from "react";

const mystyle = {
  right: "50%",
  border: "2px solid #22D3EE",
  borderRadius: "1%",
};

const mystyle2 = {
  left: "50%",
  border: "2px solid #22D3EE",
  borderRadius: "1%",
};

const Roadmap = () => {
  return (
    <main>
      <section className="bg-white py-8" id="roadmap">
        <div className="container mx-auto flex flex-col items-start md:flex-row my-12 md:my-24 py-16 px-4">
          <div className="flex flex-col w-full sticky md:top-36 lg:w-1/3 mt-2 md:mt-12 px-8">
            <p className="text-3xl font-semibold md:text-4xl text-purple-500 leading-normal md:leading-relaxed mb-2 lg:text-3xl">
              ROADMAP
            </p>
            <div className="mt-6">
              <a
                href="https://twitter.com/CyberRideNFT"
                className="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-gradient-to-r from-purple-500 to-cyan-500 bg-origin-border hover:bg-indigo-700"
              >
                Follow on Twitter
              </a>
            </div>
          </div>
          <div className="ml-0 md:ml-12 lg:w-2/3 sticky">
            <div className="container mx-auto w-full h-full">
              <div className="relative wrap overflow-hidden p-2 h-full tracking-normal">
                <div
                  className="border-2-2 border-green-555 absolute h-full border"
                  style={mystyle}
                ></div>
                <div
                  className="border-2-2 border-green-555 absolute h-full border"
                  style={mystyle2}
                ></div>

                <div className="mb-8 flex justify-between flex-row-reverse items-center w-full left-timeline">
                  <div className="order-1 w-5/12"></div>
                  <div className="order-1 w-5/12 px-1 py-4 text-right">
                    <h4 className="mb-3 font-bold text-black text-lg md:text-2xl">33%</h4>
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      Legendary 1/1s reveal.
                    </p>
                  </div>
                </div>

                <div className="mb-8 flex justify-between items-center w-full right-timeline">
                  <div className="order-1 w-5/12"></div>
                  <div className="order-1  w-5/12 px-1 py-4 text-left">
                    <h4 className="mb-3 font-bold text-black text-lg md:text-2xl"> 66%</h4>
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      Sneak peek for 2D Isometric Pixel Version of CyberRide reveals.
                    </p>
                  </div>
                </div>

                <div className="mb-8 flex justify-between flex-row-reverse items-center w-full left-timeline">
                  <div className="order-1 w-5/12"></div>
                  <div className="order-1 w-5/12 px-1 py-4 text-right">
                    <h4 className="mb-3 font-bold text-black text-lg md:text-2xl"> 100%</h4>
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      Ride images disclose shortly after all rides sold out to ensure fairness. Cyberride Gallery goes live on CyberRide.io, showcasing model attributes and rarity.
                    </p>
                    <br />
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      OBJ download becomes available on CyberRide.io for ride owners.
                    </p>
                  </div>
                </div>

                <div className="mb-8 flex justify-between items-center w-full right-timeline">
                  <div className="order-1 w-5/12"></div>
                  <div className="order-1 w-5/12 px-1 py-4 text-left">
                    <p className="mb-3 font-bold text-cyan-400 tracking-wide">After Gen-1</p>
                    <h4 className="mb-3 font-bold text-black text-lg md:text-2xl tracking-wide"> Push for Mass Adoption</h4>
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      We will push the support for CyberRide models in major game/platforms, including ████████████, ███ ███████, and ██████.
                    </p>
                    <br />
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      By supporting games with millions of players, we can help push NFTs closer to mass adoption.
                    </p>
                    <br />
                  </div>
                </div>

                <div className="mb-8 flex justify-between flex-row-reverse items-center w-full left-timeline">
                  <div className="order-1 w-5/12"></div>
                  <div className="order-1  w-5/12 px-1 py-4">
                    <p className="mb-3 font-bold text-cyan-400 tracking-wide">After Gen-1</p>
                    <h4 className="mb-3 font-bold text-black text-lg md:text-2xl text-left tracking-wide">Interoperable API</h4>
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      Build a more user-friendly import process to use CyberRide across different platforms. The improved flow and API would apply to all digital items designed for the Metaverse.
                    </p>
                  </div>
                </div>

                <div className="mb-8 flex justify-between items-center w-full right-timeline">
                  <div className="order-1 w-5/12"></div>
                  <div className="order-1 w-5/12 px-1 py-4 text-left">
                    <h4 className="mb-3 font-bold text-black text-lg md:text-2xl tracking-wide"> Gen-2</h4>
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      ██,███ models of CyberRide Gen-2 are already in the works. Newly purchased CyberRide Gen-2 models have a ██% chance of collecting a CyberRide Gen-3 model for free.
                    </p>
                    <br />
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      CyberRide models claimed for free do not unlock future generation CyberRide.
                    </p>
                  </div>
                </div>

                <div className="mb-8 flex justify-between flex-row-reverse items-center w-full left-timeline">
                  <div className="order-1 w-5/12"></div>
                  <div className="order-1  w-5/12 px-1 py-4">
                    <h4 className="mb-3 font-bold text-black text-lg md:text-2xl text-left tracking-wide">Gen-3 and Beyond</h4>
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      Continue to develop new CyberRide models with the latest technology and design tools available. Improve interactivity, composability and interoperability so CyberRide can be seamlessly imported and used in any Metaverse.
                    </p>
                    <br />
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      The CyberRide community will collectively decide the future direction of the project.
                    </p>
                    <br />
                    <p className="text-base md:text-base leading-snug text-black text-opacity-100 tracking-wide">
                      Stay tuned.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Roadmap;
